module.exports = __webpack_public_path__ + "img/5.685e2ab8.jpeg";